import '../sass/content-tabs.scss';

(() => {
    const $blocks = document.querySelectorAll('.content-tabs');

    $blocks?.forEach($block => {
        const $tabsContentCarousel = $block.querySelector('.content-tabs__tabs-content-carousel');
        const $tabsNavButtons = $block.querySelectorAll('.content-tabs__tabs-nav-button');
        const $detailsTabs = $block.querySelectorAll('.content-tabs__details-tab');

        const initDetails = () => {
            if (!$detailsTabs) return;

            $detailsTabs.forEach($detailsTab => {
                new Details($detailsTab);
            });
        };

        const initCarousel = () => {
            if (!$tabsContentCarousel) return;

            const carousel = new Swiper($tabsContentCarousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false,
            });

            carousel.on('slideChange', () => {
                if ($tabsNavButtons) {
                    $tabsNavButtons.forEach($button => {
                        if ($button.dataset.index == carousel.activeIndex) {
                            $button.classList.add('content-tabs__tabs-nav-button--active');
                        } else {
                            $button.classList.remove('content-tabs__tabs-nav-button--active');
                        }
                    });
                }
            })

            if ($tabsNavButtons) {
                $tabsNavButtons.forEach($button => {
                    $button.addEventListener('click', e => {
                        e.preventDefault();
                        
                        carousel.slideTo($button.dataset.index);
                    });
                });
            }
        };

        initDetails();
        initCarousel();
    });
})();
